module.exports = __webpack_public_path__ + "static/media/dropdown.1619720c.jpg";